import { render, staticRenderFns } from "./PendingTasksManager.vue?vue&type=template&id=3b3a89e1"
import script from "./PendingTasksManager.vue?vue&type=script&lang=js"
export * from "./PendingTasksManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports